export const ADD_FUND = "ADD_FUND";
export const ADD_COMPETITION_INFO = "ADD_COMPETITION_INFO";
export const ADD_COMPETITION = "ADD_COMPETITION";
export const UPDATE_FUND = "UPDATE_FUND";
export const REMOVE_FUND = "REMOVE_FUND";
export const CLEAR_CART = "CLEAR_CART";
export const MODEL_PERCENTAGE_TOTAL = "MODEL_PERCENTAGE_TOTAL";
export const UPDATE_FUND_MODEL_PERCENTAGE = "UPDATE_FUND_MODEL_PERCENTAGE";
export const CART_STATE = "CART_STATE";
export const MODEL_PORTFOLIO_NAME = "MODEL_PORTFOLIO_NAME";
export const MODEL_PORTFOLIO_ID = "MODEL_PORTFOLIO_ID";
export const PUNCTUAL_CONTRIBUTION_PORTFOLIO_ID = "PUNCTUAL_CONTRIBUTION_PORTFOLIO_ID";
export const SET_CART_SENDING = "SET_CART_SENDING";